const PrivacyPolicy = {
  seo: {
    title: 'Privacy Policy',
  },

  title: 'Privacy Policy',
};

export default PrivacyPolicy;
